// src/components/BookFinder/GenreSelector.js
import React from 'react';
import './GenreSelector.css';

// We now add an imageUrl for each genre
const genres = [
  { name: 'Science Fiction', value: 'science_fiction', imageUrl: '/images/science_fiction.png' },
  { name: 'Fantasy', value: 'fantasy', imageUrl: '/images/fantasy.png' },
  { name: 'Mystery', value: 'mystery', imageUrl: '/images/mystery.png' },
  { name: 'Romance', value: 'romance', imageUrl: '/images/romance.png' },
  { name: 'History', value: 'history', imageUrl: '/images/history.png' },
  { name: 'Horror', value: 'horror', imageUrl: '/images/horror.png' },
  { name: 'Thriller', value: 'thriller', imageUrl: '/images/thriller.png' },
  { name: 'Adventure', value: 'adventure', imageUrl: '/images/adventure.png' },
];

const GenreSelector = ({ onGenreChange }) => {
  return (
    <div className="genre-grid-container">
      <h2>Browse Genres</h2>
      <div className="genre-grid">
        {genres.map((genre) => (
          <div 
            key={genre.value} 
            className="genre-card"
            // We use an inline style to set the background image for each card
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL + genre.imageUrl})` }}
            onClick={() => onGenreChange(genre.value)}
          >
            <span>{genre.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GenreSelector;